// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__2pq8t","divider":"NavItem_divider__qshj_","iconChip":"NavItem_iconChip__1pmCc","title":"NavItem_title__3SuRi","subText":"NavItem_subText__3Nwet"};